import 'owl.carousel'
import { CountUp } from 'countup.js';
import "magnific-popup";
// import AOS from 'aos';

// JavaScript
$(document).ready( function () {
  // header
  $('.menu-link').click(function(e) {
      $(this).parent().toggleClass('active').siblings().removeClass('active');
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  $(window).on('scroll', function () {
    // transparent header
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  });

  var countUp_sponsor = new CountUp('sponsor', 544186, 3000, { enableScrollSpy: true });
  countUp_sponsor.start();
  var countUp_students = new CountUp('students', 316535, 3000, { enableScrollSpy: true });
  countUp_students.start();

  // 計算 "持續關懷" 天數
  const startDate = new Date('1999-05-20'); // 客戶指定的起始日期
  startDate.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffInDays = Math.floor((today - startDate) / (1000 * 60 * 60 * 24)) + 1;
  var countUp_days = new CountUp('days', diffInDays, 3000, { enableScrollSpy: true });
  countUp_days.start();


  // scroll top
  $('#backTop').click(function(){
    $("html,body").animate({scrollTop: 0}, 600);
  });

  // video
  $('.popup-video').magnificPopup({
    type: 'iframe'
  });
});
